import httpClient from "../../../shared/api/httpClient";

// Link de assinatura da agenda (.ics) — Apple Calendar, Outlook, Google por URL etc.
// O backend devolve só o `path`; a URL completa usa a mesma baseURL da API.
export const agendaFeedApi = {
  getStatus: () => httpClient.get("/api/v1/agenda-feed").then((r) => r.data.dados),
  ativar: () => httpClient.post("/api/v1/agenda-feed").then((r) => r.data.dados),
  regenerar: () => httpClient.post("/api/v1/agenda-feed/regenerar").then((r) => r.data.dados),
  desativar: () => httpClient.delete("/api/v1/agenda-feed").then((r) => r.data.dados),
};

export function agendaFeedUrl(path) {
  return `${httpClient.defaults.baseURL.replace(/\/$/, "")}${path}`;
}

// webcal:// faz o sistema abrir o app de agenda padrão já na tela de assinatura.
export function agendaFeedWebcalUrl(path) {
  return agendaFeedUrl(path).replace(/^https?:\/\//, "webcal://");
}
